import api from './api';

export interface ServiceProviderWithdrawRule {
  id: string;
  allowAlipay: boolean;
  allowWechatWallet: boolean;
  allowBankCard: boolean;
  securityDepositAmount: number;
  settlementDelayDays: number;
  settlementFlowMode: 'order_completed' | 'sub_order_completed';
  withdrawAuditMode: 'immediate_arrival' | 'manual_review';
  withdrawExecuteMode: 'mock' | 'real';
  withdrawServiceFeeBearer: 'platform' | 'provider';
  wechatMchId: string;
  wechatAppId: string;
  wechatSerialNo: string;
  wechatPayPublicKeyId: string;
  wechatApiV3Key: string;
  wechatWithdrawNotifyUrl: string;
  wechatDepositPayNotifyUrl: string;
  wechatPayPublicKey: string;
  wechatPrivateKey: string;
  wechatConfigRemark: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface UpdateServiceProviderWithdrawRuleRequest {
  allowAlipay: boolean;
  allowWechatWallet: boolean;
  allowBankCard: boolean;
  securityDepositAmount: number;
  settlementDelayDays: number;
  settlementFlowMode: 'order_completed' | 'sub_order_completed';
  withdrawAuditMode: 'immediate_arrival' | 'manual_review';
  withdrawExecuteMode: 'mock' | 'real';
  withdrawServiceFeeBearer: 'platform' | 'provider';
  wechatMchId: string;
  wechatAppId: string;
  wechatSerialNo: string;
  wechatPayPublicKeyId: string;
  wechatApiV3Key: string;
  wechatWithdrawNotifyUrl: string;
  wechatDepositPayNotifyUrl: string;
  wechatPayPublicKey: string;
  wechatPrivateKey: string;
  wechatConfigRemark: string;
}

export const getServiceProviderWithdrawRule = () => api.get<ServiceProviderWithdrawRule>('/service-provider-withdraw-rule');

export const updateServiceProviderWithdrawRule = (data: UpdateServiceProviderWithdrawRuleRequest) =>
  api.put<ServiceProviderWithdrawRule>('/service-provider-withdraw-rule', data);
